import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { cloneDeep } from "lodash";

// Components
import Icon from "../../Icon";
import color from "../../../assets/color";

// UI Component
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";

let fields = {
  country_code: "+60",
  phone_no: "",
  code1: "",
  code2: "",
  code3: "",
  code4: "",
  password: "",
  confirm_password: ""
};

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: "1",
      verificationCodeSent: false,
      invalidVerificationCode: false,
      resendTime: 60,
      fields: { ...fields }
    };
  }
  componentDidMount() {
    this._resetFields();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.SMSSent !== this.props.SMSSent) {
      if (this.props.SMSSent) {
        this._onCodeSent();
      }
    }

    if (prevProps.codeVerified !== this.props.codeVerified) {
      if (this.props.codeVerified) {
        this.setState({ step: "3" });
      }
    }

    if (prevProps.passwordReset !== this.props.passwordReset) {
      if (this.props.passwordReset) {
        this.setState({ step: "4" });
      }
    }
  }

  componentWillMount() {
    clearInterval(this.intervalId);
  }

  _sendCode = () => {
    const value = cloneDeep(this.state.fields);

    let params = {
      oper: "resetpass",
      country_code: value.country_code,
      phone_no: value.phone_no
    };
    this.props.onSentCode(params);
  };

  _verifyCode = data => {
    let fields = cloneDeep(this.state.fields);
    fields = { ...fields, ...data };
    this.setState({ fields }, () => {
      if (!this.props.codeVerified) {
        const value = cloneDeep(this.state.fields);

        let params = {
          oper: "resetpass",
          country_code: value.country_code,
          phone_no: value.phone_no,
          veri_code: value.code1 + value.code2 + value.code3 + value.code4
        };

        this.props.onVerifyCode(params);
      } else {
        this.setState({ step: "3" });
      }
    });
  };

  _resetPassword = () => {
    let value = cloneDeep(this.state.fields);

    let phoneNo = value.phone_no;
    if (phoneNo.charAt(0) === "0") {
      phoneNo = phoneNo.substring(1);
    }

    let params = {
      country_code: value.country_code,
      phone_no: phoneNo,
      veri_code: value.code1 + value.code2 + value.code3 + value.code4,
      password: value.password
    };

    this.props.onSubmit(params);
  };

  _resetFields = () => {
    this.setState({ step: "1", fields });
  };

  _updateData = (data, step) => {
    let fields = cloneDeep(this.state.fields);
    fields = { ...fields, ...data };
    this.setState({ fields, step });
  };

  _onSubmit = data => {
    let fields = cloneDeep(this.state.fields);
    fields = { ...fields, ...data };
    this.setState({ fields }, () => {
      this._resetPassword();
    });
  };

  _handleChangePhone = () => {
    let data = cloneDeep(this.state.fields);
    data.code1 = "";
    data.code2 = "";
    data.code3 = "";
    data.code4 = "";

    this.setState(
      {
        fields: data,
        verificationCodeSent: false,
        resendTime: 60
      },
      () => {
        this._clearTimer();
      }
    );
  };

  _onCodeSent = () => {
    this.setState({ verificationCodeSent: true }, () => {
      this._resendTimer();
    });
  };

  /* ===== Timer ===== */
  _resendTimer() {
    this.setState({ resendTime: 60 }, () => {
      this.intervalId = setInterval(() => {
        this._updateTimer();
      }, 1000);
    });
  }

  _updateTimer() {
    let remainingTime = this.state.resendTime - 1;

    this.setState(
      {
        resendTime: remainingTime
      },
      () => {
        if (remainingTime < 1) {
          this._clearTimer();
        }
      }
    );
  }

  _clearTimer = () => {
    clearInterval(this.intervalId);
  };
  /* ===== END Timer ===== */

  render() {
    const { codeVerified } = this.props;
    const { step, fields, verificationCodeSent, resendTime } = this.state;

    return (
      <Row noGutters={true}>
        {step !== "4" && (
          <Col xs={12} lg={6}>
            <div className="inner-container grey d-flex flex-column justify-content-between align-items-center">
              <div className="d-lg-none d-xl-none position-relative align-self-end">
                <div className="btn-close" onClick={this.props.onHide}>
                  <Icon
                    type="custom"
                    name="closecircle"
                    color={color.black}
                    size={30}
                  />
                </div>
              </div>
              <div className="title flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center">
                <Icon
                  type="custom"
                  name="login"
                  color={color.black}
                  className="icon-login"
                />
                <h1>Forgot Password</h1>
              </div>

              <p className="mb-0 d-none d-lg-block d-xl-block">
                <span
                  className="clickable font-weight-bold"
                  onClick={this.props.goToLogin}
                >
                  Back To Login
                </span>
              </p>
            </div>
          </Col>
        )}
        <Col xs={12} lg={step === "4" ? 12 : 6}>
          <div className="inner-container d-flex flex-column">
            <div
              className={`${
                step !== "4" ? "d-none d-lg-block d-xl-block" : ""
              } position-relative text-right`}
            >
              <div className="btn-close" onClick={this.props.onHide}>
                <Icon
                  type="custom"
                  name="closecircle"
                  color={color.black}
                  size={30}
                />
              </div>
            </div>

            {/* STEP 1 */}
            {step === "1" && (
              <Step1
                {...this.props}
                data={{
                  country_code: fields.country_code,
                  phone_no: fields.phone_no
                }}
                onChangePhoneNo={this._handleChangePhone}
                onBack={this.props.goToLogin}
                onSubmit={this._updateData}
              />
            )}
            {/* END STEP 1 */}

            {/* STEP 2 */}
            {step === "2" && (
              <Step2
                {...this.props}
                data={{
                  country_code: fields.country_code,
                  phone_no: fields.phone_no,
                  code1: fields.code1,
                  code2: fields.code2,
                  code3: fields.code3,
                  code4: fields.code4
                }}
                verificationCodeSent={verificationCodeSent}
                codeVerified={codeVerified}
                resendTime={resendTime}
                onSendCode={this._sendCode}
                onBack={this._updateData}
                onSubmit={this._verifyCode}
              />
            )}
            {/* END STEP 2 */}

            {/* STEP 3 */}
            {step === "3" && (
              <Step3
                {...this.props}
                data={{
                  password: fields.password,
                  confirm_password: fields.confirm_password
                }}
                onBack={this._updateData}
                onSubmit={this._onSubmit}
              />
            )}
            {/* END STEP 3 */}

            {/* STEP 4 */}
            {step === "4" && <Step4 />}
            {/* END STEP 4 */}
          </div>
        </Col>
        {step !== "4" && (
          <Col xs={12} lg={6} className="d-lg-none d-xl-none">
            <div className="inner-container grey">
              <p className="text-center mb-0">
                <span
                  className="clickable font-weight-bold"
                  onClick={this.props.goToLogin}
                >
                  Back To Login
                </span>
              </p>
            </div>
          </Col>
        )}
      </Row>
    );
  }
}

ForgotPassword.propTypes = {
  codeNotVerified: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  // Function
  goToLogin: PropTypes.func.isRequired,
  onSentCode: PropTypes.func.isRequired
};

export default ForgotPassword;
